import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetInvitationsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => async (dispatch, store) => {

        dispatch({ type: types.GET_INVITATIONS_COMPLETED, payload: null });

        const orgId = store().currentuser.currentorganization.id;
        const apiName = "OrganizationInvitations";

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Invitations/" + apiName + "/" + orgId + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_INVITATIONS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveInvitationPagination: (paginationType) => (dispatch, store) => {
        const data = store().administration.invitations;
        dispatch({ type: types.GET_INVITATIONS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetInvitation: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Invitations/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteInvitation: (InvitationId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Invitations/" + InvitationId, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.invitationDeleted);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditInvitation: (changedInvitation, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Invitations/" + changedInvitation.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedInvitation),
            method: "PUT"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    CreateInvitation: (newInvitation, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Invitations", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newInvitation),
            method: "POST"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    }

};
